import { Component, type ErrorInfo, type ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const err = this.state.error;
    return (
      <div className="min-h-screen bg-background text-foreground p-6 flex flex-col items-center justify-center gap-4 text-center">
        <TriangleAlert className="w-8 h-8 text-red-400" aria-hidden />
        <h2 className="text-lg font-bold">Что-то сломалось</h2>
        <p className="text-sm text-muted-foreground max-w-md">
          {err.message || 'Неизвестная ошибка'}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="bg-primary text-primary-foreground px-5 py-2 rounded-xl text-sm font-bold"
        >
          Перезагрузить
        </button>
      </div>
    );
  }
}
